import type { PurchaseHistory } from '../modules/DataTransformSchema';

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

const extractDateFromText = (input: string): Date | null => {
  if (!input) return null;
  const trimmed = input.trim();
  const monthPattern =
    /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s+\d{4}\b/i;
  const matchedDate = trimmed.match(monthPattern);
  if (matchedDate) {
    const parsed = new Date(matchedDate[0]);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }
  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const parseOrderDate = (dateString: string): Date | null => {
  if (!dateString) return null;
  const match = dateString.match(/Ordered on (.+)/i);
  const candidate = match ? match[1] : dateString;
  return extractDateFromText(candidate);
};

export const getOrderDate = (order: PurchaseHistory): Date | null => {
  const value = order.order_date;
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (Array.isArray(value)) {
    const first = value[0];
    if (first instanceof Date) {
      return Number.isNaN(first.getTime()) ? null : first;
    }
    if (typeof first === 'string') {
      return parseOrderDate(first);
    }
    return null;
  }
  if (typeof value === 'string') {
    return parseOrderDate(value);
  }
  return null;
};
